import { SvgIconComponent } from '@mui/icons-material'

import { RoleEnum } from '../features/account'

export class Page {
  id: string
  href: string
  localizationKey: string
  type: string
  groupId?: string
  iconUrl?: string
  iconComponent?: SvgIconComponent | undefined
  startUrl?: string
  hideWithoutRole?: RoleEnum | RoleEnum[] // hide page completely if user does not have one of these roles
  showBetaBadge?: boolean // show beta badge on page
  title?: string

  constructor(
    id: string,
    href: string,
    localizationKey: string,
    type: string,
    groupId?: string,
    iconUrl?: string,
    iconComponent?: SvgIconComponent | undefined,
    startUrl?: string,
    hideWithoutRole?: RoleEnum | RoleEnum[],
    showBetaBadge?: boolean,
    title?: string
  ) {
    this.id = id
    this.href = href
    this.localizationKey = localizationKey
    this.type = type
    this.groupId = groupId
    this.iconUrl = iconUrl
    this.iconComponent = iconComponent
    this.startUrl = startUrl
    this.hideWithoutRole = hideWithoutRole
    this.showBetaBadge = showBetaBadge
    this.title = title
  }
}
